export enum OutOfStateDonorType {
  Instate = 0,
  OutOfState = 1,
  Both = 2,
}
